<template>
    <section class="card-container">
      <!-- Primeiro Card -->
      <div class="card">
        <img src="../assets/imag tec/sitesite-removebg-preview.png" alt="Serviço 1" class="card-image"/>
        <h2>Criação de Sites</h2>
        <p>Seu site, à sua maneira. Desenvolvemos sites totalmente personalizados
           para as suas necessidades, garantindo que sua identidade única brilhe na internet. 
           Nosso serviço de criação de sites une design inovador, 
           tecnologia de ponta e uma experiência de usuário impecável,
            criando a ferramenta perfeita para você alcançar seus objetivos.</p>
      </div>
      <!-- Segundo Card -->
      <div class="card">
        <img src="../assets/imag tec/criacao-de-sites-removebg-preview.png" alt="Serviço 2" class="card-image"/>
        <h2>Criação API</h2>
        <p>Desenvolvemos APIs sob medida para o seu projeto. Seja para um aplicativo móvel, um sistema de e-commerce ou uma plataforma de análise de dados, criamos a infraestrutura de comunicação que você precisa. Nossa abordagem personalizada garante que a API não só atenda às suas necessidades atuais, mas também suporte o crescimento e a inovação futura do seu negócio.</p>
      </div>
      <!-- Terceiro Card -->
      <div class="card">
        <img src="../assets/imag tec/criação_de_curso-removebg-preview.png" class="card-image"/>
        <h2>Cursos e Consutoria online</h2>
        <p>Oferecemos uma combinação de cursos online e consultoria personalizada para profissionais e empresas que buscam dominar novas tecnologias. Nossos cursos, focados em conhecimento prático, são complementados por sessões de consultoria individual, onde você pode tirar dúvidas, resolver problemas complexos e planejar seus próximos passos. Aprenda no seu ritmo e receba a orientação de quem realmente entende do assunto.</p>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: "CardService", // Nome do componente
  };
  </script>
  
  <style scoped>
  /* Estilos para o container de cards */
  .card-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); /* Responsivo */
    gap: 20px; /* Espaçamento entre os cards */
    padding: 5px;
   background-color: transparent !important;
    border: none; /* Removidas as bordas */
    border-radius: 10px;
    box-shadow: none; /* Removida a sombra */
    margin: 0 auto; /* Centraliza o container */
    max-width: 1400px; /* Limita a largura máxima */
    color: #03522d;
  }
  
  /* Estilo de cada card */
  .card {
    background-color: #ffffff; 
    border: none; /* Removidas as bordas */
    box-shadow: none; /* Removida a sombra */
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    color: #ffffff;
    ;
     
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center; /* Centraliza o conteúdo dentro do card */
    justify-content: space-between; /* Espaça uniformemente o conteúdo */
    height: 100%;
  }
  
  /* Estilo para a imagem */
  .card-image {
    width: 100%; /* Tornando a imagem 100% da largura do card */
    height: 200px; /* Mantém a altura fixa */
    object-fit: cover; /* Mantém a proporção da imagem sem distorção */
    border-radius: 8px;
    margin-bottom: 15px; /* Espaço entre a imagem e o título */
    transition: transform 0.3s ease; /* Suaviza o zoom da imagem */
  }
  
  /* Efeito de hover na imagem para zoom */
  .card-image:hover {
    transform: scale(1.1); /* Aumenta a imagem 10% */
  }
  
  /* Efeito de hover no card */
  .card:hover {
    transform: translateY(-20px);
     
    /* Removido o fundo cinza */
    

  }
   
  /* Estilo do título do card */
  .card h2 {
    font-size: 1.5rem;
      color: #06e40e;
    margin: 10px 0;
    font-weight: bold;
  }
  
  /* Estilo da descrição do card */
  .card p {
    font-size: 1rem;
    color: #ffffff;
    line-height: 1.5;
    margin: 0;
  }
  
  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    .card-container {
      grid-template-columns: 1fr; /* Coloca os cards em uma coluna em dispositivos menores */
      padding: 10px;
    }
  
    /* Ajusta a imagem para que ela ocupe toda a largura no mobile */
    .card-image {
      height: 150px; /* Reduz a altura da imagem para dispositivos menores */
    }
  
    /* Ajusta o tamanho do texto para melhor legibilidade em telas menores */
    .card h2 {
      font-size: 1.2rem;
    }
  
    .card p {
      font-size: 0.9rem;
    }
  }
  
  @media (max-width: 480px) {
    .card h2 {
      font-size: 1rem;
    }
  
    .card p {
      font-size: 0.8rem;
    }
  }
  </style>
  